import { Command } from '../types/command';

// Varsayılan komutları oluştur
export const defaultCommands: Command[] = [
  {
    name: 'help',
    descriptionKey: 'commands.help.description',
    category: 'system',
    functionName: 'showHelp',
    isVisible: true
  },
  {
    name: 'clear',
    descriptionKey: 'commands.clear.description',
    category: 'system',
    functionName: 'clearTerminal',
    isVisible: true
  },
  {
    name: 'about',
    descriptionKey: 'commands.about.description',
    category: 'info',
    functionName: 'showAbout',
    isVisible: true
  },
  {
    name: 'skills',
    descriptionKey: 'commands.skills.description',
    category: 'info',
    functionName: 'showSkills',
    isVisible: true
  },
  {
    name: 'projects',
    descriptionKey: 'commands.projects.description',
    category: 'info',
    functionName: 'showProjects',
    isVisible: true
  },
  {
    name: 'experience',
    descriptionKey: 'commands.experience.description',
    category: 'info',
    functionName: 'showExperience',
    isVisible: true
  },
  {
    name: 'education',
    descriptionKey: 'commands.education.description',
    category: 'info',
    functionName: 'showEducation',
    isVisible: true
  },
  {
    name: 'homepage',
    descriptionKey: 'commands.homepage.description',
    category: 'navigation',
    functionName: 'switchToHomePage',
    isVisible: true
  },
  {
    name: 'home',
    descriptionKey: 'commands.homepage.description',
    category: 'navigation',
    functionName: 'switchToHomePage',
    isVisible: false
  },
  {
    name: 'anasayfa',
    descriptionKey: 'commands.homepage.description',
    category: 'navigation',
    functionName: 'switchToHomePage',
    isVisible: false
  },
  {
    name: 'contact',
    descriptionKey: 'commands.contact.description',
    category: 'info',
    functionName: 'showContact',
    isVisible: true
  },
  {
    name: 'cv',
    descriptionKey: 'commands.cv.description',
    category: 'action',
    functionName: 'downloadCV',
    isVisible: true,
    parameters: [
      {
        name: 'language',
        descriptionKey: 'parameters.language',
        isRequired: false
      }
    ]
  },
  {
    name: 'theme',
    descriptionKey: 'commands.theme.description',
    category: 'system',
    functionName: 'changeTheme',
    isVisible: true,
    parameters: [
      {
        name: 'themeName',
        descriptionKey: 'parameters.theme',
        isRequired: false
      }
    ]
  },
  {
    name: 'language',
    descriptionKey: 'commands.language.description',
    category: 'system',
    functionName: 'changeLanguage',
    isVisible: true,
    parameters: [
      {
        name: 'languageCode',
        descriptionKey: 'parameters.language',
        isRequired: false
      }
    ]
  },
  {
    name: 'echo',
    descriptionKey: 'commands.echo.description',
    category: 'system',
    functionName: 'echo',
    isVisible: true,
    parameters: [
      {
        name: 'text',
        descriptionKey: 'parameters.text',
        isRequired: true
      }
    ]
  },
  {
    name: 'date',
    descriptionKey: 'commands.date.description',
    category: 'system',
    functionName: 'showDate',
    isVisible: true
  },
  {
    name: 'github',
    descriptionKey: 'commands.github.description',
    category: 'link',
    functionName: 'openGithub',
    isVisible: true
  },
  {
    name: 'linkedin',
    descriptionKey: 'commands.linkedin.description',
    category: 'link',
    functionName: 'openLinkedin',
    isVisible: true
  },
  {
    name: 'twitter',
    descriptionKey: 'commands.twitter.description',
    category: 'link',
    functionName: 'openTwitter',
    isVisible: true
  },
  {
    name: 'classic',
    descriptionKey: 'commands.classic.description',
    category: 'system',
    functionName: 'switchToClassic',
    isVisible: true
  },
  {
    name: 'services',
    descriptionKey: 'commands.services.description',
    category: 'navigation',
    functionName: 'services',
    isVisible: true
  }
];

// Yazılan komutu otomatik tamamlama
export const autocompleteCommand = (input: string, commands: Command[]): string[] => {
  // Input yoksa boş dizi döndür
  if (!input || !input.trim()) return [];
  
  // Küçük harfe çevir
  const inputLower = input.trim().toLowerCase();
  
  // İlk olarak tam eşleşmelere bak
  const exactMatches = commands
    .filter(cmd => cmd.name.toLowerCase() === inputLower && cmd.isVisible)
    .map(cmd => cmd.name);
  
  if (exactMatches.length > 0) {
    return exactMatches;
  }
  
  // Sonra ile başlayan komutları bul
  const startsWith = commands
    .filter(cmd => cmd.name.toLowerCase().startsWith(inputLower) && cmd.isVisible)
    .map(cmd => cmd.name);
  
  // Son olarak içinde geçen komutları bul (daha düşük öncelik)
  if (startsWith.length === 0) {
    const contains = commands
      .filter(cmd => cmd.name.toLowerCase().includes(inputLower) && cmd.isVisible)
      .map(cmd => cmd.name);
    
    return contains;
  }
  
  return startsWith;
};

// Komut işleme
export const processCommand = (
  input: string, 
  commands: Command[],
  language?: string
): { command: Command | null; params: string[] } => {
  const parts = input.trim().split(/\s+/);
  const commandName = parts[0].toLowerCase();
  const params = parts.slice(1);
  
  const command = commands.find(cmd => cmd.name === commandName);
  
  return {
    command: command || null,
    params
  };
}; 